import React, { useState, useContext } from 'react'
import { AuthContext } from '../../contexts/auth'
import { useNavigate } from 'react-router-dom'
import { api, createSessionResponsible } from '../../Api'
import { FiUser, FiLock, FiEye, FiEyeOff, FiAlertCircle, FiArrowLeft } from 'react-icons/fi'

import {
    Container,
    Brand,
    BrandMark,
    BrandBody,
    BrandTitle,
    BrandSubtitle,
    BrandFoot,
    FormSide,
    InputArea,
    FormHeading,
    FormTitle,
    FormHint,
    Field,
    Area,
    Input,
    EyeButton,
    Btt,
    AccessTopButton,
    ErrorBanner
} from './style'

import { AtomLogo } from "../../components/AtomLogo";
import { InstallAppButton } from '../../components/InstallAppButton';

import LoadingSpinner from '../../components/Loading'

const SignInResponsible = () => {
    const navigate = useNavigate()
    const { loginResponsible } = useContext(AuthContext)
    const [cpf, setCpf] = useState('')
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const canSubmit = cpf.trim().length > 0 && password.trim().length > 0 && !loading

    const SignClick = async (e) => {
        if (e && e.preventDefault) e.preventDefault()
        if (!canSubmit) return

        setErrorMessage('')
        setLoading(true)
        try {
            // envia apenas dígitos do CPF
            const rawCpf = cpf.replace(/\D/g, '')
            const response = await createSessionResponsible(rawCpf, password)

            if (response && response.data && response.data.token) {
                const id = response.data.id
                const loggedResponsible = response.data.CPF
                const token = response.data.token
                const name = response.data.name
                const type = response.data.type

                const now = Date.now()
                localStorage.setItem('lastLogin', now)

                localStorage.setItem('Id_responsible', JSON.stringify(id))
                sessionStorage.setItem('cpf', loggedResponsible)
                sessionStorage.setItem('name', name)
                localStorage.setItem('name', name)
                localStorage.setItem('type', type)
                localStorage.setItem('token', token)
                sessionStorage.setItem('token', token)

                api.defaults.headers.Authorization = `Bearer ${token}`
                loginResponsible(loggedResponsible)
            } else {
                setErrorMessage('CPF ou senha incorretos. Verifique e tente novamente.')
                setLoading(false)
            }
        } catch (err) {
            console.error('Erro ao entrar:', err)
            const msg = err?.response?.data?.msg
            setErrorMessage(msg || 'Não foi possível entrar. Confira seus dados e a conexão, e tente novamente.')
            setLoading(false)
        }
    }

    const maskCPF = (value) => {
        return value
            .replace(/\D/g, '')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
            .slice(0, 14)
    }

    const handleChange = (e) => {
        setCpf(maskCPF(e.target.value))
        if (errorMessage) setErrorMessage('')
    }

    if (loading) {
        return <LoadingSpinner />
    }

    return (
        <Container>
            <Brand>
                <BrandMark>
                    <AtomLogo size={48} nucleus="#ffffff" />
                    <span>Diário Escolar Virtual</span>
                </BrandMark>
                <BrandBody>
                    <BrandTitle>Portal dos Pais ou Responsável</BrandTitle>

                    <BrandSubtitle>
                        Acompanhe notas, frequência e relatórios escolares dos seus dependentes em um só lugar.
                    </BrandSubtitle>
                </BrandBody>

                <BrandFoot>
                    Ambiente Integrado de Gestão Escolar
                </BrandFoot>
            </Brand>

            <FormSide>
                <InputArea onSubmit={SignClick}>
                    <AccessTopButton
                        type="button"
                        onClick={() => navigate('/signin/employee')}
                    >
                        <FiArrowLeft size={15} /> Acesso da instituição
                    </AccessTopButton>

                    <FormHeading>
                        <FormTitle>Entrar</FormTitle>
                        <FormHint>Use seu CPF e senha cadastrados na escola.</FormHint>
                    </FormHeading>

                    {errorMessage && (
                        <ErrorBanner role="alert">
                            <FiAlertCircle size={16} /> {errorMessage}
                        </ErrorBanner>
                    )}

                    <Field>
                        CPF
                        <Area $error={!!errorMessage}>
                            <FiUser size={18} />
                            <Input
                                placeholder="000.000.000-00"
                                value={cpf}
                                onChange={handleChange}
                                type="text"
                                inputMode="numeric"
                                autoComplete="username"
                                maxLength="14"
                            />
                        </Area>
                    </Field>

                    <Field>
                        Senha
                        <Area $error={!!errorMessage}>
                            <FiLock size={18} />
                            <Input
                                placeholder="Digite sua senha"
                                value={password}
                                type={showPassword ? 'text' : 'password'}
                                autoComplete="current-password"
                                onChange={(e) => { setPassword(e.target.value); if (errorMessage) setErrorMessage('') }}
                            />
                            <EyeButton
                                type="button"
                                onClick={() => setShowPassword(s => !s)}
                                aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                                title={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                            >
                                {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                            </EyeButton>
                        </Area>
                    </Field>

                    <Btt type="submit" disabled={!canSubmit}>Entrar</Btt>

                    <InstallAppButton variant="login" />
                </InputArea>
            </FormSide>
        </Container>
    )
}

export default SignInResponsible